import { IconProps } from '../../icons/types';

const GreyCircleIcon = (props: IconProps) => {
  const { width = 18, height = 18, fillColor = '#E8E8E8' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill={fillColor} stroke="#E8E8E8" />
    </svg>
  );
};

export default GreyCircleIcon;
